<div class="dialog">
  <div class="dialog-background" (click)="close()"></div>
  <div class="dialog-content">
    <span (click)="close()" id="close" class="icon-i-close"></span>
    <!-- Headline -->
    <h2>
      {{ (stepStatus === 5 ? 'modals.promotions.h2' : 'modals.promotions-referrals.h2-both') | translate }}
    </h2>
    <p>
      {{ (stepStatus === 5 ? 'modals.promotions.enterPromo' : 'modals.promotions.enterBoth') | translate }}
    </p>
    <!-- Input for promo, success or error message -->
    <div class="input-block" [ngClass]="{ error: issueLabel }">
      <div class="code-block">
        <input [(ngModel)]="promotionsCode" type="text" />
      </div>
      <ng-container *ngIf="advancedIssue(); else simpleIssue">
        <div class="pending-promotions error" *ngIf="!(kind === '3a' && moneyPromotions)">
          <span class="icon-i-close-circle"></span>
          <p>{{ 'modals.promotions.' + issueLabel | translate }}</p>
        </div>
        <div class="pending-promotions note" *ngIf="kind === '3a' && moneyPromotions">
          <span class="icon-i-info"></span>
          <p>{{ 'modals.promotions.3aMoneyError' | translate }}</p>
        </div>
      </ng-container>
      <ng-template #simpleIssue>
        <p class="error" *ngIf="issueLabel">{{ 'modals.promotions.' + issueLabel | translate }}</p>
      </ng-template>
      <div class="feedback-box success" *ngIf="success">
        <span class="icon-i-checkmark-circle"></span>
        <p>{{ 'modals.promotions.success' | translate }}</p>
      </div>
    </div>
    <button (click)="submit()" class="ui-button full-width">
      {{ 'modals.promotions.cta' | translate }}
    </button>
  </div>
</div>
